export default __webpack_public_path__ + "static/media/Graphik-Black-Web.5e8bd16c.woff";